// Add General Info Page
export const GET_TENANT_DETAILS = 'GET_TENANT_DETAILS';
export const GET_UNIT_DETAILS = 'GET_UNIT_DETAILS';
export const GET_LEASE_TERMS = 'GET_LEASE_TERMS';
export const GET_BOOKING_TERMS = 'GET_BOOKING_TERMS';
export const GET_PAYMENT_SCHEDULE = 'GET_PAYMENT_SCHEDULE';